// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__20J91","title":"Footer_title__1vzSm","socials":"Footer_socials__3KxrV","desktop":"Footer_desktop__3QNc6","mobile":"Footer_mobile__Ef_2N"};